import { Checkboard } from 'react-color/lib/components/common';

const CheckboardBackground = () => (
  <div className="do-not-export">
    <Checkboard />
  </div>
);

export default CheckboardBackground;
